export default __webpack_public_path__ + "static/dudu-5c5c3e61875a1392f4cbb4bcbfd1221c.png";